import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  confirmCancelEditNoticeTitle: {
    id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-title',
    defaultMessage: 'Changes haven’t been saved',
    description: 'Title for the notice dialog to confirm whether the user wants to discard their form changes'
  },
  confirmCancelEditNoticeBody: {
    id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-body',
    defaultMessage: 'Any changes made won’t be saved if you move away from this form.',
    description: 'Body for the notice dialog to confirm whether the user wants to discard their form changes'
  },
  confirmCancelEditNoticeCloseButton: {
    id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-close-button',
    defaultMessage: 'Cancel',
    description: 'Close button text for the notice dialog to confirm whether the user wants to discard their form changes'
  },
  confirmCancelEditNoticeConfirmButton: {
    id: 'proforma-form-system.controllers.form-index.confirm-cancel-edit-notice-confirm-button',
    defaultMessage: 'Discard changes',
    description: 'Confirm button text for the notice dialog to confirm whether the user wants to discard their form changes'
  }
});